export const DEFAULT_CUSTOMER_SERVICE_FEE = 0.035;
export const DEFAULT_TATTOO_SERVICE_ID = 'TATTOO';
export enum LoginSteps {
  Phone = 'PHONE',
  Verify = 'VERIFY',
}
